<div class="mt-1 mb-3 flex align-items-center gap-5">
  <div class="ml-auto flex gap-3">
    <label for="locked"><i class="fas fa-lock"></i></label>
    <p-triStateCheckbox
      id="locked"
      (ngModelChange)="updateFilter()"
      [(ngModel)]="filterQuery.locked"
      inputId="published" />
  </div>
  <div class="flex gap-3 align-items-center">
    <label for="category"><i class="fas fa-folder"></i></label>
    <p-treeSelect
      id="category"
      containerStyleClass="w-30rem"
      *ngIf="store.asTree() as categories"
      selectionMode="multiple"
      (onNodeSelect)="addCategoryToQuery($event)"
      (onNodeUnselect)="removeCategoryFromQuery($event)"
      [filter]="true"
      placeholder="Bereiche"
      [options]="categories">
      <ng-template let-expanded pTemplate="itemtogglericon">
        <i
          class="tree-category-icon"
          [ngClass]="!expanded ? 'fas fa-folder' : 'fas fa-folder-open'"></i>
      </ng-template>
    </p-treeSelect>
  </div>
  <div class="flex">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="fas fa-search" />
      <input
        class="w-20rem"
        pInputText
        placeholder="durchsuchen ..."
        [(ngModel)]="filterQuery.query"
        (ngModelChange)="updateFilter()" />
    </p-iconField>
  </div>
</div>
